"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 19,
    height: 18,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("path", {
    d: "M6.313 9.671a1.25 1.25 0 00-1.292 0L2.81 11.006a.25.25 0 01-.373-.271l.587-2.515a1.25 1.25 0 00-.399-1.229L.671 5.298a.25.25 0 01.142-.438l2.572-.218a1.25 1.25 0 001.045-.758L5.436 1.51a.25.25 0 01.46 0l1.007 2.374c.181.427.583.719 1.045.758l2.572.218a.25.25 0 01.142.438L8.708 6.991A1.25 1.25 0 008.31 8.22l.587 2.515a.25.25 0 01-.373.27l-2.21-1.334z",
    fill: "#fff",
    stroke: "#6F6F6F"
  }));
}
var _default = exports.default = SvgComponent;